import moment from 'moment';
import 'moment/locale/pt'  // without this line it didn't work

export function formatDateLocale(date: string) {
  return moment(date).locale(navigator?.language[0] || 'pt').format('LLLL')
}